import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Pager } from '../model/pager';
import { Identity } from '@sdbn/common';
import { PagerDetails } from '../model/pager-details';
import { ServiceResponse } from '@sdbn/common';

@Injectable({
    providedIn: 'root'
  })
  export class PagereService {

    constructor(private appServerAPI: AppServerAPI) { }

    getPagers(): Observable<Pager[]> {
      return this.appServerAPI.execute<Pager[]>('/client/admin/pager', {});
    }

    getPagerDetails(identity: Identity): Observable<PagerDetails> {
      return this.appServerAPI.execute<PagerDetails>('/client/admin/pager/details', identity);
    }

    savePager(smartphone: PagerDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/pager/save', smartphone);
    }

    createPager(smartphone: PagerDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/pager/create', smartphone);
    }

    deletePager(identity: Identity): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/pager/delete', identity);
    }
  }
